<template>
  <div>
    <!-- Modal Structure -->
    <div id="modal-bottom" class="modal bottom-sheet" >
      <div class="modal-content" v-if="editValues.title && !isNew ">
        <h4>Editar {{ getTitle( editValues.title ) }} </h4>
        <p> Nombre: <br />
          <input type="text" id="name_bottom_modal" v-on:focus=" $event.target.select() " :value="editValues.name">
        </p>
        <p>
          Comentarios: <br />
          <textarea id="descripcion_bottom_modal"  v-on:focus=" $event.target.select() " class="materialize-textarea" cols="30" rows="5" :value="editValues.descripcion" > </textarea>
        </p>
      </div>

      <div class="modal-content" v-else>
         <h4>Nuevo elemento - {{ getTitle( editValues.title ) }} </h4>
          <p> Nombre: <br />
            <input type="text" v-model="itemSave.nombre">
          </p>
          <p>
            Comentarios: <br />
            <textarea class="materialize-textarea" cols="30" rows="5" v-model="itemSave.descripcion" > </textarea>
          </p>        
      </div>

      <div class="modal-footer">
        <a href="#!" class="modal-close red darken-4 waves-effect waves-light btn"><i class="material-icons left">close</i>Cancelar</a>
        &nbsp;
        &nbsp;
        <a href="#!" @click=" (isNew) ? EmitSave(null,'add-new',editValues.title ) : EmitSave(editValues.id,'update',editValues.title) " class="blue darken-4 waves-effect waves-light btn"><i class="material-icons left">save</i>Aceptar</a>
      </div>
    </div>    
  </div>
</template>
<style lang="scss">
  .modal-content{
    & h4{
      text-transform: capitalize;
    }
  }
</style>
<script>
export default {
  props:{
    editValues : { type:  Object, default:{} },
    isNew      : { type: Boolean, default: false }
  },
  data() {
    return {
      itemSave: {nombre:"",  descripcion: "" }, 
      saveData:{ name:"", descripcion:""}
    }
  },
  methods: {
    ShowAlert(msg){ alert(msg) },
    ValidacionInput(txt){
      // alert(txt)
      if(  txt.trim().length > 0)
        return txt;
      else 
        return false
    },
    EmitSave(_id,_action,_collection){
      let _name = "";
      let _descripcion = "";
      let _datos = {};
      if( _id != null ){
        _name         = this.ValidacionInput( document.querySelector('#name_bottom_modal').value );
        _descripcion  = document.querySelector('#descripcion_bottom_modal').value  
        _datos        = { "name":_name , "descripcion": _descripcion, 'action':_action, 'id': _id, '_target': _collection};
        
      }else{
        _name         = this.ValidacionInput(this.itemSave.nombre); 
        _datos        = { "name": _name , "descripcion": this.itemSave.descripcion, 'action':_action, '_target': _collection};
      }
      if(_name == false){
        alert("El campo nombre es obligatorio.");
      }
      else{
        this.$emit("SaveElement",_datos);
        this.itemSave = { nombre:"", descripcion:""}
      }
    },
    getTitle(_text){
      return _text.replace("_", "/");
    },
    getData(){
      return this.editValues
    }
  },
  created (){
    this.saveData = this.editValues;
  },
  // watch: {
  //   "editValues" : function(){
  //      this.saveData = this.getData() 
  //     }
  // },
}
</script>